import { FC, useEffect, useState } from 'react';
import { Solid } from './Types/Solid/Solid';
import { AllieLikeDislikeProps, SelectedSegment } from './LikeDislike.types';
import { Outline, TypeLikeDislike } from './Types';
import type { TypeLikeDislikeProps } from './Types';

const typeMap: Record<TypeLikeDislike, FC<TypeLikeDislikeProps>> = {
  solid: Solid,
  outline: Outline,
};

export const AllieLikeDislike: FC<AllieLikeDislikeProps> = ({
  onChange,
  initValue,
  value,
  disabled,
  type = 'solid',
  size = 24,
}) => {
  const [selected, setSelected] = useState<SelectedSegment | undefined>(
    initValue !== undefined ? (initValue.toString() as SelectedSegment) : undefined
  );

  useEffect(() => {
    if (value) {
      setSelected(value.toString() as SelectedSegment);
    }
  }, [value]);

  const handleChange = (e: any) => {
    setSelected(e.detail.value);
    onChange(e.detail.value === undefined ? undefined : e.detail.value === 'true');
  };

  const TypeComponent = typeMap[type];

  return <TypeComponent
    selected={selected}
    size={size}
    onChange={handleChange}
    disabled={disabled}
  />;
};
